// ts-gql-integrity:b59ab7538cd7fd375809c5ef77a06721
/*
ts-gql-meta-begin
{
  "hash": "88d43055c956b9e06f5bd0910b26e198"
}
ts-gql-meta-end
*/

import * as SchemaTypes from "./@schema";
import { TypedDocumentNode } from "@ts-gql/tag";

type UpdateTenantUserPartnerMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.TenantUserPartnerInput;
}>;


type UpdateTenantUserPartnerMutation = { readonly __typename: 'Mutation', readonly updateTenantUserPartner: boolean | null };



export type type = TypedDocumentNode<{
  type: "mutation";
  result: UpdateTenantUserPartnerMutation;
  variables: UpdateTenantUserPartnerMutationVariables;
  documents: SchemaTypes.TSGQLDocuments;
  fragments: SchemaTypes.TSGQLRequiredFragments<"none">
}>

declare module "./@schema" {
  interface TSGQLDocuments {
    UpdateTenantUserPartner: type;
  }
}

export const document = JSON.parse("{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"OperationDefinition\",\"operation\":\"mutation\",\"name\":{\"kind\":\"Name\",\"value\":\"UpdateTenantUserPartner\"},\"variableDefinitions\":[{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"input\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"TenantUserPartnerInput\"}}},\"directives\":[]}],\"directives\":[],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"updateTenantUserPartner\"},\"arguments\":[{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"input\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"input\"}}}],\"directives\":[]}]}}]}")
